import { useEffect, useState } from "react";

import { getTicketSettingsList } from "@api/e-tickets/ticket-settings";

import { URLS } from "@constants/urls";

import { PaginationRequestType } from "@type/HRM/pagination";
import {
  TicketCategoryListSettingsType,
  TicketCategorySettingsType,
} from "@type/tickets/ticket-settings";

export const useTicketCategorySettings = () => {
  const [data, setData] = useState<any>({});
  const [query, setQuery] = useState<PaginationRequestType>({
    page: 1,
    size: 10,
  });

  const handleQuery = (key: string, value: number | string | null) =>
    setQuery((prev) => ({
      ...prev,
      [key]: value,
    }));

  const handleAddNewCategory = (categoryData: TicketCategorySettingsType) => {
    setData((prevData: TicketCategoryListSettingsType) => ({
      ...prevData,
      data: [categoryData, ...prevData?.data],
    }));
  };

  const handleDeleteCategory = (categoryIdToDelete: number) => {
    setData((prevData: TicketCategoryListSettingsType) => ({
      ...prevData,
      data: prevData.data.filter(
        (categoryData) => categoryData.id !== categoryIdToDelete,
      ),
    }));
  };

  const handleUpdateCategory = (categoryData: TicketCategorySettingsType) => {
    setData((prevData: TicketCategoryListSettingsType) => ({
      ...prevData,
      data: prevData.data.map((item) =>
        item.id === categoryData.id ? categoryData : item,
      ),
    }));
  };

  useEffect(() => {
    getTicketSettingsList(URLS.TICKET_CATEGORIES, query)
      .then((data) => setData(data))
      .catch((err) => console.log(err));

    return setData({});
  }, [query]);

  return {
    ticketCategoryData: data.data,
    pagination: data.pagination,
    handleQuery,
    handleAddNewCategory,
    handleDeleteCategory,
    handleUpdateCategory,
  };
};
